import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App.tsx";
import { preloadFonts } from "@/utils/preloadFonts.ts";
import { getSavedLanguage, initI18n } from "@/i18n/i18n";

async function bootstrap() {
  await preloadFonts();
  const language = await getSavedLanguage();
  await initI18n(language);
  createRoot(document.getElementById("root")!).render(<App />);
}

bootstrap();
